import VCarousel from './VCarousel'
import VCarouselItem from './VCarouselItem'

export { VCarousel, VCarouselItem }

export default {
  $_ifrontui_subcomponents: {
    VCarousel,
    VCarouselItem,
  },
}
